import { render, staticRenderFns } from "./CreateGlobalDocumentationStep.vue?vue&type=template&id=20889ec5"
import script from "./CreateGlobalDocumentationStep.vue?vue&type=script&lang=js"
export * from "./CreateGlobalDocumentationStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports